import { Item } from 'core/domains/cart';
import { getItemBadges } from './getItemBadges';
import { getValueTag } from 'ui/containers/ContentBuilder/widgets/utilities/tag';
import type { RootState } from 'core/store';
import type { CatalogItem } from 'core/domains/catalog';
import type { ConsumerPrice, ResellerPrice } from 'ui/components';
import { getProduct } from './getters';

export const getCartItemsTracking = (prevState: RootState) => {
  const {
    cart: { data },
  } = prevState;

  const items = data?.items?.map((item: Item, index: number) => {
    const productOnList = getProduct(prevState, item?.productCode) as CatalogItem;
    const badges = getItemBadges(productOnList.tags, prevState);

    const discount = getValueTag(
      productOnList.priceWrapper?.resellerPrice as unknown as ResellerPrice,
      productOnList.priceWrapper?.consumerPrice as unknown as ConsumerPrice,
      true,
    );

    return {
      item_id: item?.productCode,
      item_name: item?.name,
      affiliation: productOnList?.tags?.length ? 'promocao' : 'padrao',
      discount,
      index: index + 1,
      item_brand: productOnList.brand || '',
      item_category: productOnList?.category || productOnList?.department || '',
      item_list_name: item?.itemListName || '',
      price: item?.priceNum,
      quantity: item?.quantity,
      cd_item_tag: badges || '',
    };
  });

  return items || [];
};
